// TODO: wait for pilot client library to implement the contract.
import { ApplicationState } from "#store/types";
import {
    Configuration,
    IdRecommendationControllerApi,
} from "@inode/pilot-client-typescript-fetch";
import { baseCfg } from "./baseCfg";

interface StringMap {
    [key: string]: string;
}
export type IDRecs = {
    recommendations: string[];
    joins: StringMap;
    error: string;
};

export type PredRecs = {
    recommendations: {};
    error: string;
};

export class PilotIdentifierRecommendationsService {
    private url: string;
    private config: Configuration;
    private userId: string;
    private database: string;
    private api: IdRecommendationControllerApi;

    constructor(state: ApplicationState) {
        this.userId = state.uiState.rid;
        this.database = state.uiState.selectedDatasource.name;
        // if (this.database == "siris") this.database = "cordis";
        // this.url = "//pilot.master.inode.iva.igd.fraunhofer.de/v2/idrecs/";
        this.url = state.environment.SERVICE_URL + "/v2/idrecs/";
        // this.url = state.environment.SERVICE_URL;
        this.config = new Configuration(
            baseCfg(state.environment.SERVICE_URL, this.userId)
        );
        this.api = new IdRecommendationControllerApi(this.config);
    }

    /**
     * TODO add actual logic for creating recommendations.
     *
     */
    getRecommendations(
        clause: string,
        pool_type: any,
        pool: string[]
    ): Promise<IDRecs> {
        const apiCall = this.api.idrecsRecommendations({
            X_Reference_ID: this.userId,
            IdRecsGetRequestBody: {
                clause: clause,
                dataset: this.database,
                poolType: pool_type,
                pool: pool,
            },
        });
        return apiCall as unknown as Promise<IDRecs>;
    }

    getPredicates(pool: string[]): Promise<PredRecs> {
        const apiCall = this.api.idrecsPredicates({
            X_Reference_ID: this.userId,
            IdRecsGetPredicatesRequestBody: {
                dataset: this.database,
                pool: pool,
            },
        });
        return apiCall as unknown as Promise<PredRecs>;
    }

    update(
        clause: string,
        identifier: string,
        reward: number,
        value: string = ""
    ): Promise<void> {
        return this.api.idrecsUpdate({
            X_Reference_ID: this.userId,
            IdRecsUpdateRequestBody: {
                clause: clause,
                dataset: this.database,
                identifier: identifier,
                reward: reward,
                value: value,
                // user: this.userId,
            },
        });
    }
}
